import { get, post, patch } from 'api/request';
import urls from 'configs/urls';

export const getAdvertsList = ({ data }) => get(null, false, urls.advertsUrls.getAdvertsList, data);

export const addAdvert = ({ data }) => post(null, false, urls.advertsUrls.addAdvert, data);

export const editAdvert = ({ advertKey, data }) =>
  patch(null, false, `${urls.advertsUrls.editAdvert}/${advertKey}`, data);
